import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { Paper, LinearProgress, Table, TableHead, TableCell, TableRow, TableBody, TablePagination } from '@material-ui/core';

import { QueryFilter, QUERY_FILTER_PUBLISHER } from 'src/component/shared';
import { PublisherWeeklyEvolutionRow } from './PublisherWeeklyEvolutionRow';
import './PublisherWeeklyEvolution.scss';

// tslint:disable-next-line:no-empty-interface
interface IPublisherWeeklyEvolutionProps {
}

// tslint:disable-next-line:no-empty-interface
interface IPublisherWeeklyEvolutionState {
    customFilter: {
        isChart: boolean
    },
    maxWeeks: number,
    page: number,
    weeksPerPage: number
}

const PUBLISHER_WEEKLY_EVOLUTION = gql`
query publisherWeeklyEvolution($customFilter:  PublisherCustomFilter) {
    publisherWeeklyEvolution(publisherCustomFilter: $customFilter) {
        code,
		name,
        data {
            code,
            name,
            billing,
            billingEvolution,
            volume,
            volumeEvolution
        }
    },
    publisherWeeklyEvolutionCurrentWeek(publisherCustomFilter: $customFilter)
}
`;

export class PublisherWeeklyEvolution extends React.Component<IPublisherWeeklyEvolutionProps, IPublisherWeeklyEvolutionState> {
    constructor(props: IPublisherWeeklyEvolutionProps) {
        super(props);
        this.state = {
            customFilter: {
                isChart: true,
            },
            maxWeeks: 1,
            page: 0,
            weeksPerPage: 5
        }
        this.handleChangePage = this.handleChangePage.bind(this);
    }

    public render() {
        const jsonFilter = {
            "customFilter": {
                "isChart": this.state.customFilter.isChart,
            }
        };

        return (<Query query={QUERY_FILTER_PUBLISHER} notifyOnNetworkStatusChange={true}  >
            {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => (
                <Query query={PUBLISHER_WEEKLY_EVOLUTION} 
                    variables={QueryFilter.getFilterPublisher(clientC, jsonFilter, ['endDate', 'initialDate'])} >
                    {({ loading, error, data, client }) => {
                        return this.dataToRend(data,loading, error);
                    }}
                </Query>

            )}
        </Query>)
    }

    /**
     * Método utilizado para renderizar as informações do card
     * Foi destacado do restante do código para que seja reutilizado nas requisições de cache e do graphql
     */
    private dataToRend (data:any, loading:any, error: any) {

        let maxWeeks = this.state.maxWeeks;
        if(data && data.publisherWeeklyEvolutionCurrentWeek) {
            const maxWeeksReturned = data.publisherWeeklyEvolutionCurrentWeek;
            if(maxWeeksReturned !== this.state.maxWeeks) {
                maxWeeks = maxWeeksReturned;
                this.setState({ maxWeeks: maxWeeksReturned });
            }
        }

        let weeks : number[] = Array.from({length:maxWeeks},(v,k)=>k+1);
        weeks.sort( (a:number, b:number) => {
            return b - a;
        });

        if(weeks && weeks.length > this.state.weeksPerPage) {
            const initialWeek = this.state.page * this.state.weeksPerPage;
            weeks = weeks.splice(initialWeek, this.state.weeksPerPage);
        }

        return (
            <Paper className="weekly-evolution-panel">
                <div className="weekly-evolution-table">

                    {loading ? 
                        <LinearProgress /> :
                        <div>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell />
                                        <TableCell className="notBreak">Grupo \ Semana</TableCell>
                                        {
                                            data && data.publisherWeeklyEvolution ? weeks.map((week: number, key: number) => {
                                                return (<TableCell className="notBreak" key={key}>{week}</TableCell>);
                                            }):null
                                        }
                                    </TableRow>
                                </TableHead>

                                {error ? 
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={maxWeeks+1} >Falha ao consultar a evolução semanal, tente novamente.</TableCell>
                                        </TableRow>
                                    </TableBody> : 
                                    
                                    <TableBody>
                                    {
                                        data && data.publisherWeeklyEvolution ? data.publisherWeeklyEvolution.map((row: any, key: number) => {
                                            return (
                                                <PublisherWeeklyEvolutionRow row={row} weeks={weeks} key={key} />
                                            );
                                        }):null
                                    }
                                    </TableBody>
                                }
                            </Table>
                            <TablePagination
                                component="div"
                                count={maxWeeks}
                                rowsPerPage={this.state.weeksPerPage}
                                page={this.state.page}
                                onChangePage={this.handleChangePage}
                            />
                        </div>
                    }
                </div>
            </Paper>
        )
    }

    private handleChangePage(ev: any, pageParam: number) {
        this.setState({ page: pageParam });
    }
}



// WEBPACK FOOTER //
// ./src/component/publisher/sale/weekly-evolution/PublisherWeeklyEvolution.tsx